import { fileDownload } from 'src/infrastructure/fileDownload'
import http from 'src/infrastructure/http'
import { parseFailedResponse, parseGoodResponse } from 'src/infrastructure/parse-axios-response'
import {
  ErrorDetails,
  ErrorTypes,
  GetSalesChannels,
  FailedUploadDetails,
  InvalidStructureDetails,
  SalesChannel,
  StockAddressing,
} from './StockAddressingInBatchTypes'

const postStockAddressingFile = async (file: File, salesChannels: SalesChannel[]) => {
  const formData = new FormData()
  formData.append('selectedFile', file)

  salesChannels.forEach((salesChannel, index) => {
    formData.append(`salesChannelIds[${index}]`, String(salesChannel.id))
  })

  try {
    const result = await http.post(
      '/v2/stock-addressing/by-excel',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )

    return parseGoodResponse<StockAddressing>(result.data)
  } catch (err: any) {
    if (err?.response?.data?.type === ErrorTypes.INVALID_STRUCTURE) {
      return parseFailedResponse<ErrorTypes.INVALID_STRUCTURE, InvalidStructureDetails>(
        ErrorTypes.INVALID_STRUCTURE,
        err?.response.data.details,
      )
    }

    return parseFailedResponse<ErrorTypes.FAILED_UPLOAD, FailedUploadDetails>(
      ErrorTypes.FAILED_UPLOAD,
      { message: err?.response?.data?.message ?? err.message },
    )
  }
}

const getSalesChannels = async ({
  fulfillmentCenterId,
}: GetSalesChannels) => {
  try {
    const response = await http.get('/v2/store/sales-channels', {
      params: {
        fulfillment_center_id: fulfillmentCenterId || undefined,
      },
    })

    return parseGoodResponse<SalesChannel[]>(response.data)
  } catch (err: any) {
    return parseFailedResponse<ErrorTypes.ERROR, ErrorDetails>(
      ErrorTypes.ERROR,
      { message: err?.response?.data?.message ?? err.message },
    )
  }
}

const getAddressingCsvFile = async (adjustmentId: number) => {
  const response = await http.get(
    `/v2/stock-addressing/${adjustmentId}/csv-result`,
    {
      responseType: 'blob',
    },
  )

  const fileName = response.headers['file-name'] || 'result.csv'

  fileDownload(response.data, fileName)
}

export default {
  getSalesChannels,
  postStockAddressingFile,
  getAddressingCsvFile,
}
